import { render, staticRenderFns } from "./SizeSelection.vue?vue&type=template&id=2c728964&scoped=true&"
import script from "./SizeSelection.vue?vue&type=script&lang=ts&"
export * from "./SizeSelection.vue?vue&type=script&lang=ts&"
import style0 from "./SizeSelection.vue?vue&type=style&index=0&id=2c728964&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c728964",
  null
  
)

export default component.exports